export default __webpack_public_path__ + "static/media/zoldhitel.92250757.webp";